// extracted by mini-css-extract-plugin
export default {"header":"Heading_header__4NUEb","tooltipIcon":"Heading_tooltipIcon__cvMvh"};